import { render, staticRenderFns } from "./WantSell.vue?vue&type=template&id=4ffccb46&scoped=true"
import script from "./WantSell.vue?vue&type=script&lang=js"
export * from "./WantSell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffccb46",
  null
  
)

export default component.exports